import React from 'react';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import style from '../../../styles/styles';
import PropTypes from 'prop-types';
import {grey400} from 'material-ui/styles/colors';
import gravatar from 'gravatar'
import {Link} from "react-router-dom";
import Avatar from 'material-ui/Avatar';
import {ListItem} from 'material-ui/List';
import AdminService, {SUPER_ADMIN} from "../../../services/admin";
import withTranslation from "../../../hoc/withTranslation";
import {ADMIN_PAGE, EDIT_ADMIN_PAGE} from "../../../constants/routes";

class Admin extends React.Component {

    static propTypes = {
        user: PropTypes.object.isRequired,
        admin: PropTypes.object.isRequired,
        handleRemoveAdmin: PropTypes.func
    };

    handleRemoveAdmin = () => {
        this.props.handleRemoveAdmin(this.props.admin);
    };

    rightIconButton = () => {
        const iconButtonElement = (
            <IconButton
                touch={true}
                tooltipPosition="bottom-left"
            >
                <MoreVertIcon color={grey400}/>
            </IconButton>
        );

        return (
            <IconMenu
                iconButtonElement={iconButtonElement}
                listStyle={style.list}
                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                targetOrigin={{horizontal: 'right', vertical: 'top'}}>
                <Link to={ADMIN_PAGE.replace(':adminId', this.props.admin.id)}>
                    <MenuItem>
                        {this.props.t('generic.detail')}
                    </MenuItem>
                </Link>
                {AdminService.isAuthorized(SUPER_ADMIN, this.props.user) &&
                    <Link to={EDIT_ADMIN_PAGE.replace(':adminId', this.props.admin.id)}>
                        <MenuItem>
                            {this.props.t('generic.edit')}
                        </MenuItem>
                    </Link>
                }
                {AdminService.isAuthorized(SUPER_ADMIN, this.props.user) && this.props.handleRemoveAdmin &&
                    <MenuItem onClick={this.handleRemoveAdmin}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                }
            </IconMenu>
        )
    };

    render() {
        const {admin} = this.props;

        return (
            <ListItem
                leftAvatar={<Avatar src={gravatar.url(admin.email)} size={40}/>}
                primaryText={admin.firstname && admin.lastname && admin.firstname + ' ' + admin.lastname}
                secondaryText={admin.email}
                rightIconButton={this.rightIconButton()}
            />
        );
    }
}

export default withTranslation(Admin);



// WEBPACK FOOTER //
// src/components/admin/Admin/Admin.js